import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from "@angular/core";

export interface AutoTextPanelSnippet {
  SnippetID: number;
  Content: string;
  AutoTextListID: number;
  ListTitle: string;
}

@Component({
    selector: "app-autotext-panel",
    templateUrl: "./autotext-panel.component.html",
    styleUrls: ["./autotext-panel.component.scss"],
    standalone: false
})
export class AutotextPanelComponent implements OnChanges {
  @Input() snippets: AutoTextPanelSnippet[] = [];
  @Input() display = false;
  @Output() insert = new EventEmitter<string>();
  @Output() close = new EventEmitter<void>();

  selectedCategory: string = null;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.display && this.display) {
      this.selectedCategory = null;
    }
  }

  get categories(): string[] {
    const seen = new Set<string>();
    for (const s of this.snippets || []) seen.add(s.ListTitle);
    return [...seen];
  }

  snippetsFor(listTitle: string): AutoTextPanelSnippet[] {
    return (this.snippets || []).filter((s) => s.ListTitle === listTitle);
  }

  openCategory(listTitle: string) {
    this.selectedCategory = listTitle;
  }

  backToCategories() {
    this.selectedCategory = null;
  }

  pick(s: AutoTextPanelSnippet) {
    this.insert.emit(s.Content);
  }

  doClose() {
    this.selectedCategory = null;
    this.close.emit();
  }
}
